export class AnalyticsReportRequest {
    public kpi: string;
    public timePeriod: string;
    public date: string;
    public isCouponOrders: boolean;
    constructor() {}
}
